import { supabase, SUPABASE_URL } from '@/integrations/supabase/client';

/**
 * Triggers immediate processing of the campaign queue and email queue.
 * Call this after enrolling a lead to avoid waiting for the 5-minute cron job.
 */
export async function triggerImmediateEmailProcessing(brandId: string): Promise<void> {
  try {
    console.log('[triggerImmediateEmailProcessing] Triggering campaign queue processor for brand:', brandId);
    
    // Call the universal-campaign-queue-processor edge function
    const { data, error } = await supabase.functions.invoke('universal-campaign-queue-processor', {
      body: { brand_id: brandId },
    });

    if (error) {
      console.error('[triggerImmediateEmailProcessing] Error:', error);
    } else {
      console.log('[triggerImmediateEmailProcessing] Result:', data);
    }
  } catch (err) {
    // Non-critical - cron job will pick it up if this fails
    console.error('[triggerImmediateEmailProcessing] Failed (non-critical):', err);
  }
}
